import { makeStyles } from '@material-ui/core/styles'
import { toolbarHeight } from 'src/Constants'

export const toolBarStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: toolbarHeight - 1,
    background: theme.palette.geoColors.contextBar.main,
    display: 'flex',
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.geoColors.contextBar.dark,
    borderBottomStyle: 'solid'
  },
  breadcrumb: {
    display: 'table'
  },
  breadcrumbText: {
    maxWidth: 150,
    height: toolbarHeight,
    lineHeight: `${toolbarHeight}px`,
    fontSize: '0.9rem',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    userSelect: 'none'
  },
  homeIcon: {
    color: theme.palette.primary.main
  },
  breadcrumbSeparator: {
    marginLeft: -5,
    marginRight: 5,
    color: theme.palette.geoColors.topBar.main,
    height: toolbarHeight
  },
  separatorBar: {
    height: toolbarHeight,
    lineHeight: `${toolbarHeight - 5}px`,
    fontSize: '2rem',
    fontWeight: 100,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.geoColors.topBar.main
  },
  toolParamsWrapper: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    marginTop: theme.spacing(0.8),
    marginBottom: theme.spacing(0.8),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.geoColors.toolBar.light
  },
  noToolSelected: {
    background: theme.palette.geoColors.contextBar.main,
    width: '100%'
  },
  models: {
    width: '20%',
    maxWidth: 200,
    marginRight: theme.spacing(2)
  }
}))
